{
  "version": 1,
  "asset_id": "d5735f23-5c5a-4af5-a478-84fc055abcfe",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/d5735f23-5c5a-4af5-a478-84fc055abcfe/ind-security-automation-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/d5735f23-5c5a-4af5-a478-84fc055abcfe/ind-security-automation-1200.avif",
  "original_filename": "ind-security-automation-1200.avif",
  "size": 7966,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:15Z"
}
